<template>
  <div class="App">
    <MenuComponent />
    <router-view/>
  </div>
</template>

<script>
import MenuComponent from "@/components/menu/Menu"


export default {
  components: {
    MenuComponent
  }
}
</script>

<style lang="scss">
.App {
    display: flex;
    width: 100%;
    align-items: stretch;
}
</style>
